export const LAYOUT_FETCH_REQUESTED = 'LAYOUT_FETCH_REQUESTED'
export const LAYOUT_FETCH_SUCCESS = 'LAYOUT_FETCH_SUCCESS'
export const LAYOUT_SAVE_REQUESTED = 'LAYOUT_SAVE_REQUESTED'
export const LAYOUT_SAVE_SUCCESS = 'LAYOUT_SAVE_SUCCESS'
export const OVERVIEW_FETCH_DONE = 'OVERVIEW_FETCH_DONE'
export const OVERVIEW_OFFICE_FETCH_REQUESTED = 'OVERVIEW_OFFICE_FETCH_REQUESTED'
export const OVERVIEW_OFFICE_FETCH_SUCCESS = 'OVERVIEW_OFFICE_FETCH_SUCCESS'
export const OVERVIEW_USER_FETCH_REQUESTED = 'OVERVIEW_USER_FETCH_REQUESTED'
export const OVERVIEW_USER_FETCH_SUCCESS = 'OVERVIEW_USER_FETCH_SUCCESS'
export const MY_TASKS_FETCH_REQ = 'MY_TASKS_FETCH_REQ'
export const MY_TASKS_FETCH_DONE = 'MY_TASKS_FETCH_DONE'
export const MY_ACTIVE_FETCH_REQ = 'MY_ACTIVE_FETCH_REQ'
export const MY_ACTIVE_FETCH_DONE = 'MY_ACTIVE_FETCH_DONE'
export const OVERVIEW_ALL_FETCH_REQUESTED = 'OVERVIEW_ALL_FETCH_REQUESTED'
export const OVERVIEW_ALL_FETCH_SUCCESS = 'OVERVIEW_ALL_FETCH_SUCCESS'
export const OVERVIEW_ALL_OFFICE_FETCH_REQUESTED = 'OVERVIEW_ALL_OFFICE_FETCH_REQUESTED'
export const OVERVIEW_ALL_OFFICE_FETCH_SUCCESS = 'OVERVIEW_ALL_OFFICE_FETCH_SUCCESS'
export const OVERVIEW_ALL_USER_FETCH_REQUESTED = 'OVERVIEW_ALL_USER_FETCH_REQUESTED'
export const OVERVIEW_ALL_USER_FETCH_SUCCESS = 'OVERVIEW_ALL_USER_FETCH_SUCCESS'
export const PROPOSALS_FOR_REVIEW_FETCH_REQ = 'PROPOSALS_FOR_REVIEW_FETCH_REQ'
export const PROPOSALS_FOR_REVIEW_FETCH_DONE = 'PROPOSALS_FOR_REVIEW_FETCH_DONE'
export const PROPOSALS_TO_REVIEW_FETCH_REQ = 'PROPOSALS_TO_REVIEW_FETCH_REQ'
export const PROPOSALS_TO_REVIEW_FETCH_DONE = 'PROPOSALS_TO_REVIEW_FETCH_DONE'
export const PROPOSALS_UPDATE_FETCH_REQ = 'PROPOSALS_UPDATE_FETCH_REQ'
export const PROPOSALS_UPDATE_FETCH_DONE = 'PROPOSALS_UPDATE_FETCH_DONE'
export const PROPOSALS_CLIENT_FETCH_REQ = 'PROPOSALS_CLIENT_FETCH_REQ'
export const PROPOSALS_CLIENT_FETCH_DONE = 'PROPOSALS_CLIENT_FETCH_DONE'
export const OVERVIEW_WAS_CALLED = 'OVERVIEW_WAS_CALLED'
export const GET_PROPOSALS_IN_REVIEW_FETCH_REQUESTED = 'GET_PROPOSALS_IN_REVIEW_FETCH_REQUESTED'
export const GET_PROPOSALS_IN_REVIEW_FETCH_SUCCESS = 'GET_PROPOSALS_IN_REVIEW_FETCH_SUCCESS'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const DASHBOARD_UPDATE_NEW_DEALS_COUNTER = 'DASHBOARD_UPDATE_NEW_DEALS_COUNTER'
export const DASHBOARD_UPDATE_NEW_PROPOSALS_COUNTER = 'DASHBOARD_UPDATE_NEW_PROPOSALS_COUNTER'
